module.exports = __webpack_public_path__ + "img/uni.a4880d72.svg";